import React, { FC, useContext } from 'react';
import ConsentContext, { ConsentProvider, EConsentUiState } from '../../contexts/ConsentContext';
import BasicLayout from '../../layout/BasicLayout/BasicLayout';
import ConsentForm from '../../components/ConsentForm/ConsentForm';
import Loader from '../../components/Loader/Loader';
import { ERoutes } from '../../util/constants';
import { Redirect } from 'react-router-dom';

const ConsentUi: FC = () => {
    const { consentUiState, redirectUrl } = useContext(ConsentContext);
    switch (consentUiState) {
        case EConsentUiState.default:
        case EConsentUiState.queryStringParsed:
            return <Loader />;
        case EConsentUiState.ready:
        case EConsentUiState.loading:
            return <ConsentForm />;
        case EConsentUiState.success:
            return (
                <>
                    <Loader />
                    {window.location.assign(redirectUrl)}
                </>
            );
        case EConsentUiState.fatalError:
            return <Redirect to={ERoutes.error} />;
        default:
            <Redirect to={ERoutes.error} />;
            throw Error('consent Ui State set incorrectly');
    }
};

const ConsentScreen: FC = () => {
    return (
        <ConsentProvider>
            <BasicLayout>
                <ConsentUi />
            </BasicLayout>
        </ConsentProvider>
    );
};

export default ConsentScreen;
